import {atom,} from "recoil";

export const contactContentSelectedInBusiness = atom<string>({
    key: 'contactContentSelectedInBusiness',
    default: 'ITシステムAPP開発について'
})